import lrDepartmentSelect from './_src/lrDepartmentSelect.vue'
lrDepartmentSelect.install = function(Vue) {
  Vue.component(lrDepartmentSelect.name, lrDepartmentSelect)
}

export default lrDepartmentSelect